module.exports = __webpack_public_path__ + "img/defence-24.35a26ca3.svg";